"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'FormSelect',
  props: {
    val: {
      type: [String, Number, Boolean, Array, Object, Date],
      default: ''
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // select
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'code'
    },
    // 当allow-create模式下，对输入的文案长度做限制
    maxlength: {
      type: Number,
      default: 0
    },
    // placeholder
    placeholder: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    change: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      inputVal: this.val
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    // 是否可输入模式
    isIptMode: function isIptMode() {
      return this.$attrs.hasOwnProperty('allow-create') && !!this.maxlength;
    },
    placeholderTxt: function placeholderTxt() {
      var txt = '';
      if (this.placeholder) {
        txt = this.placeholder;
      } else if (this.isIptMode) {
        txt = this.$t('common.pleaseSelectOrInput');
      } else {
        txt = this.$t('common.pleaseSelect');
      }
      return this.isDisabled ? '' : txt;
    }
  },
  watch: {
    val: {
      deep: true,
      immediate: true,
      handler: function handler(newVal) {
        this.inputVal = newVal;
      }
    }
  },
  mounted: function mounted() {
    this.initMaxlength();
  },
  methods: {
    // 当allow-create模式下，对输入的文案长度做限制
    initMaxlength: function initMaxlength() {
      if (this.isIptMode) {
        var parentDom = this.$refs['select'].$el || undefined;
        if (parentDom) {
          // console.log(222, parentDom.querySelector('input'))
          var iptDom = parentDom.querySelector('input');
          iptDom && iptDom.setAttribute('maxlength', this.maxlength);
        }
      }
    },
    onChange: function onChange(val) {
      if (this.isDisabled) {
        return false;
      }
      this.$emit('update:val', val);
      this.change(val);
    }
  }
};